export default __webpack_public_path__ + "static/media/text-field-icon.ea6338bb.svg";